import './_swym-button.scss';

export default () => {};
